import React, { useRef, useState } from 'react';
import Password from './Password';

const Change_pass = () => {
    const [state, setState] = useState(false);
    const usernameRef = useRef("");
    const passRef = useRef("");

    const onSubmit = event => {
        event.preventDefault();

        if (usernameRef.current.value === "morshed" && passRef.current.value === "morshed") {
            setState(true);
        } else {
            alert("Not matched!");
        }
    }

    return (
        <div className="center-admin">
            {
                state ||
                <form className="form-admin d-flex flex-column p-5 bg-dark" onSubmit={onSubmit}>
                    <input ref={usernameRef} type="text" placeholder="username" />
                    <input ref={passRef} type="text" placeholder="password" />
                    <input className="btn btn-info" type="submit" value="SUBMIT" />
                </form>
            }
            {
                state && <Password />
            }
        </div>
    );
};

export default Change_pass;